import cn from "classnames";
import StringToJSX, {
  type StringToJSXProps,
} from "@/components/common/StringToJSX";

export type ParagraphProps = Omit<StringToJSXProps, "text"> &
  Partial<Pick<StringToJSXProps, "text">>;

export default function Paragraph(props: ParagraphProps) {
  const { text, ...restProps } = props;

  if (!text) return null;

  const className = cn(props.className, "informa-formatted-text");

  return <StringToJSX text={text} {...restProps} className={className} />;
}
